import React from "react";
import { motion } from "framer-motion";
import IPhoneMockup from "@/components/IPhoneMockup";
import { APP_SCREENS, APP_SCREENS_ALT } from "@/lib/assets";

/**
 * Bottom showcase for the "Gespeichert" feature.
 * Single iPhone, clean and prominent — exactly one usage per spec.
 */
export default function SavedShowcaseSection({ t }) {
  const fade = (delay = 0) => ({
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <section
      className="section-pad-sm saved-showcase"
      data-testid="saved-showcase-section"
    >
      <div className="max-w-[1200px] mx-auto px-5 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <motion.div {...fade()} className="section-label" data-testid="saved-label">
            {t("home.saved.label")}
          </motion.div>
          <motion.h2 {...fade(0.05)} className="display-md">
            <span className="block">{t("home.saved.h2a")}</span>
            <span className="block italic">{t("home.saved.h2b")}</span>
          </motion.h2>
          <motion.p {...fade(0.1)} className="body-lg mt-5 max-w-[520px]">
            {t("home.saved.sub")}
          </motion.p>
          <motion.ul {...fade(0.18)} className="saved-bullets mt-8 space-y-3">
            {t("home.saved.bullets").map((b, i) => (
              <li key={i} className="flex items-start gap-3 body-md">
                <span className="saved-bullet-dot" aria-hidden="true" />
                <span>{b}</span>
              </li>
            ))}
          </motion.ul>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 flex justify-center">
          <motion.div {...fade(0.12)} className="saved-phone-wrap">
            <IPhoneMockup
              width={300}
              image={APP_SCREENS.saved}
              alt={APP_SCREENS_ALT.saved}
              testId="saved-phone"
              priority
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
